// https://vuex.vuejs.org/en/actions.html

export default {
    setChecked({ commit }, payload) {
        commit('SET_CHECKED', payload);
    },
    setUser({ commit }, payload) {
        commit('SET_USER', payload);
    },
    setNewOrder({ commit }, payload) {
        commit('SET_newOrder', payload);
    },
    openModal({ commit }, payload) {
        commit('OPEN_MODAL', payload);
    },
    selectValue({ commit }, payload) {
        commit('SET_VALUE', payload);
    },
    setLastUpdate({ commit }, payload) {
        commit('SET_LAST_UPDATE', payload);
    }
}
